import { Content, Header, Page } from '@backstage/core-components';
import {
  EntityListDocsTable,
  TechDocsPicker,
} from '@backstage/plugin-techdocs';
import {
  EntityListProvider,
  EntityOwnerPicker,
  UserListPicker,
} from '@backstage/plugin-catalog-react';
import { makeStyles } from '@material-ui/core/styles';
import {
  getCompleteTableStyles,
} from '../styles/sharedStyles';

const useStyles = makeStyles(theme => ({
  pageContainer: {
    padding: 0,
  },
  contentFullWidth: {
    padding: theme.spacing(3, 5, 5, 5),
    backgroundColor: 'transparent',
  },
  tableWrapper: {
    ...getCompleteTableStyles(theme),

    '& [class*="BackstageTableToolbar-root"]': {
      padding: 0,
      marginBottom: theme.spacing(3),
    },
  },
}));

export const CustomTechDocsIndexPage = () => {
  const classes = useStyles();

  return (
    <Page themeId="documentation">
      <Header title="Documentation" />
      <Content className={classes.contentFullWidth}>
        <EntityListProvider>
          <div style={{ display: 'none' }}>
            <TechDocsPicker />
            <UserListPicker initialFilter="all" />
            <EntityOwnerPicker />
          </div>
          <div className={classes.tableWrapper}>
            <EntityListDocsTable />
          </div>
        </EntityListProvider>
      </Content>
    </Page>
  );
};
